// extracted by mini-css-extract-plugin
export var clicked = "index-module--clicked--YS2gQ";
export var cls1 = "index-module--cls1--uH0l9";
export var cls2 = "index-module--cls2--ASfo9";
export var cls3 = "index-module--cls3--skjj-";
export var down = "index-module--down--XgKkg";
export var menu = "index-module--menu--reP+w";
export var middle = "index-module--middle--WD0Iq";
export var notHome = "index-module--notHome--StVWO";
export var up = "index-module--up--t5Ekr";